<template>
  <div class="login">
    <div style="text-align: center;">
      <van-image
        width="200px"
        fit="contain"
        :src="require('../assets/img/logo.png')"
        style="margin-bottom: 40px;"
      />
    </div>
    <div class="header">
      <span>Welcome To Porsche Training Passport</span>
      <div>
        欢迎使用保时捷培训护照
        <van-image :src="require('../assets/img/login-img.png')" width="47" height="8" />
      </div>
    </div>
    <div style="text-align: center;">
      <van-image :src="require('../assets/img/map.png')" fit="cover" />
    </div>
    <!-- <div v-if="!relationShow" class="sumbit-btn" @click="setWechat">
      微信授权
    </div> -->
    <van-form @submit="onSubmit" ref="validForm">
      <van-field
        v-model="username"
        name="PPN 账号"
        label=""
        placeholder="请输入 PPN 账号"
        :rules="[{ required: true, message: '' }]"
        @blur="handleBlur"
      />
      <!-- <van-field
        v-model="password"
        name="密码"
        label=""
        placeholder="请输入 密码"
        :rules="[{ required: true, message: '' }]"
      /> -->
      <div class="sumbit-btn" @click="onSubmit">登录</div>
      <!-- <span @click="forgetPwd" class="forget-pwd">忘记密码</span> 
      <van-popup v-model:show="showCenter" closeable :style="{ padding: '30px' }">
        请发邮件至{{ mailTo }}进行申请修改！</van-popup
      >-->
    </van-form>
  </div>
</template>

<script>
import { relationPPN, getUserInfo, getEmail, loginByWechat, login } from '@/api/index.js'
import { Notify } from 'vant'

export default {
  name: 'Login',
  data() {
    return {
      showCenter: false,
      mailTo: '',
      username: '',
      password: '',
      currentCode: '',
      currentOpenId: '',
      relationShow: false,
    }
  },
  methods: {
    setWechat() {
      let jumpUrl = 'https://porsche-lp.rps-china.com.cn'
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx827aa5cff11c458c&redirect_uri=${jumpUrl}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    },
    handleBlur() {
      window.scroll(0, 0)
    },
    forgetPwd() {
      getEmail().then((res) => {
        this.mailTo = res.msg
        this.showCenter = true
      })
    },
    onSubmit() {
      this.$refs.validForm.validate().then(() => {
        relationPPN({
          ppn: this.username,
          openid: this.currentOpenId,
        }).then((res) => {
          if (res.code != 200) {
            Notify({ type: 'warning', message: res.msg })
          } else {
            localStorage.setItem('porsche-token', res.data.token)
            // this.getUser(res.data.user.id)
            localStorage.setItem('userName', res.data.user.name)
            localStorage.setItem('user', JSON.stringify(res.data.user))
            localStorage.setItem('userType', res.data.user.type)
            if (res.data.user.type == '0') {
              //集团
              this.$router.push('/index')
            } else if (res.data.user.type == '1') {
              //经销商
              this.$router.push({
                path: '/dealerIndex',
                query: { id: res.data.user.dealerId },
              })
            } else if (res.data.user.type == '2') {
              //学员
              this.$router.push('/user/passport')
            }
          }
        })
      })
      // // login({
      // //     password: this.password,
      // //     ppn: this.username,
      // //   }).then((res) => {
      // //     if (res.code != 200) {
      // //       Notify({ type: 'warning', message: res.msg })
      // //     } else {
      // //       localStorage.setItem('porsche-token', res.data.token)
      // //       this.getUser(res.data.id)
      // //     }
      // //   })
      // // })
      // .catch(() => {
      //   console.log('failed')
      //})
    },
    getUser(id) {
      getUserInfo({ id: id }).then((res) => {
        localStorage.setItem('userName', res.data.name)
        localStorage.setItem('user', JSON.stringify(res.data))
        localStorage.setItem('userType', res.data.type)
        if (res.data.type == '0') {
          //集团
          this.$router.push('/index')
        } else if (res.data.type == '1') {
          //经销商
          this.$router.push({
            path: '/dealerIndex',
            query: { id: res.data.dealerId },
          })
        } else if (res.data.type == '2') {
          //学员
          this.$router.push('/user/passport')
        }
      })
    },
    getCode(url) {
      var temp1 = url.split('?')
      var pram = temp1[1]
      var keyValue = pram.split('&')
      var obj = {}
      for (var i = 0; i < keyValue.length; i++) {
        var item = keyValue[i].split('=')
        var key = item[0]
        var value = item[1]
        obj[key] = value
      }
      return obj
    },
  },
  mounted() {
    this.currentCode = this.getCode(window.location.href).code
    if (this.currentCode) {
      loginByWechat({
        code: this.currentCode,
      }).then((res) => {
        if (res.data.login == '0') {
          this.relationShow = true
          this.currentOpenId = res.data.openid
        } else if (res.data.login == '1') {
          localStorage.setItem('porsche-token', res.data.token)
          this.getUser(res.data.id)
        }
      })
    } else {
      this.setWechat()
    }

    // if (localStorage.getItem('user')) {
    //   let res = {
    //     data: JSON.parse(localStorage.getItem('user')),
    //   }
    //   if (res.data.type == '0') {
    //     //集团
    //     this.$router.push('/index')
    //   } else if (res.data.type == '1') {
    //     //经销商
    //     this.$router.push({
    //       path: '/dealerIndex',
    //       query: { id: res.data.dealerId },
    //     })
    //   } else if (res.data.type == '2') {
    //     //学员
    //     this.$router.push('/user/passport')
    //   }
    // }
  },
  created() {
    //console.log(document.body.scrollTop)
  },
}
</script>

<style scoped lang="scss">
.login {
  height: 100%;
  background-color: #fff;
  padding: 80px 24px 0;
  .header {
    font-family: 'Porsche Next';
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    font-size: 20px;
    font-weight: 500;
    span {
      font-size: 14px;
      color: #333;
      opacity: 0.9;
    }
  }
  .van-cell {
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    height: 40px;
    line-height: 18px;
    margin-bottom: 10px;
  }
  .forget-pwd {
    float: right;
    font-size: 12px;
    color: #333;
    border-bottom: 1px solid #333;
  }
  .sumbit-btn {
    margin-top: 30px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #dd3349;
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    box-shadow: 0 0 15px #dd3349;
    border-radius: 4px;
    margin-bottom: 20px;
  }
}
</style>
